import { Outlet } from 'react-router-dom';

import SiteFooter from 'components/SiteFooter';
import SiteHeader from 'components/SiteHeader';
import Toast from 'components/Toast';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FullScreenLayout: FunctionComponent<Props> = ({ testId = TEST_ID }) => (
    <>
        <div className={styles.fullScreenLayout} data-testid={testId}>
            <SiteHeader />

            <main className={styles.main}>
                <Outlet />
            </main>

            <SiteFooter className={styles.siteFooter} />
        </div>

        <Toast />
    </>
);

export default FullScreenLayout;
